export default __webpack_public_path__ + "static/media/pricing4.ea95f54a.jpg";